import { DefaultTheme } from "styled-components";
import cejamLogo from "./logo.png";
import cejamBackground from "./background.png";

export const cejamTheme: DefaultTheme = {
  title: "cejam",

  colors: {
    primary: "#19304A",
    secondary: "#A4C628",
    chatMessage: "#49A1B5",
    header: "#19304A",
  },

  images: {
    logo: cejamLogo,
    background: cejamBackground,
  },
};
